import {  useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Scroll window to top
    window.scrollTo(0, 0);
    
    // Also scroll any main content containers to top
    // This handles the case where the main content area has its own scroll
    const mainElements = document.querySelectorAll('main, [data-scroll-container]');
    mainElements.forEach(element => {
      element.scrollTop = 0;
    });
    
    // Alternative approach: find elements with overflow-auto or overflow-scroll
    const scrollableElements = document.querySelectorAll('[class*="overflow-auto"], [class*="overflow-scroll"]');
    scrollableElements.forEach(element => {
      element.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}
